export default __webpack_public_path__ + "static/media/chat-blue.4cfec1d2.svg";